import useSWR from 'swr';
import type { Workspace } from '@/lib/api/types';
import { useUser } from './use-user';

interface CurrentWorkspaceResponse {
  currentWorkspace: Workspace | null;
}

const fetcher = async (url: string): Promise<CurrentWorkspaceResponse> => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Failed to fetch current workspace');
  }
  return response.json();
};

export function useCurrentWorkspace() {
  const { user } = useUser();
  
  const { data, error, isLoading, isValidating, mutate } = useSWR<CurrentWorkspaceResponse>(
    user ? '/api/workspaces/current' : null,
    fetcher,
    {
      keepPreviousData: true,
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
    }
  );

  return {
    currentWorkspace: data?.currentWorkspace || null,
    error,
    isLoading: isLoading && !data, // Only show loading on initial load, not revalidation
    isValidating,
    mutate,
  };
} 